import { useAdversarialStore, getSelectedRun } from '../../stores/useAdversarialStore';
import styles from './Adversarial.module.css';

export function TraceView() {
  const state = useAdversarialStore();
  const { selectRun } = state;
  const selectedRun = getSelectedRun(state);

  if (!selectedRun) {
    return (
      <div className={styles.emptyState}>
        <div className={styles.emptyIcon}>◇</div>
        <div className={styles.emptyText}>Select a run to view its execution trace</div>
      </div>
    );
  }

  return (
    <div className={styles.tracePanel}>
      <div className={styles.traceHeader}>
        <span className={styles.traceTitle}>Trace: {selectedRun.label}</span>
        <button className={styles.backBtn} onClick={() => selectRun(null)}>
          ← Back
        </button>
      </div>

      <table className={styles.traceTable}>
        <thead>
          <tr>
            <th>Step</th>
            <th>Node</th>
            <th>Action</th>
            <th>Result</th>
            <th>Changes</th>
          </tr>
        </thead>
        <tbody>
          {selectedRun.executionTrace.map(step => (
            <tr
              key={step.index}
              className={step.status === 'error' ? styles.traceStepError : styles.traceStepSuccess}
            >
              <td>{step.index + 1}</td>
              <td>#{step.nodeId} ({step.nodeType})</td>
              <td>{step.operation}</td>
              <td>
                {step.status === 'error' ? (
                  <span className={styles.statusFailed}>{step.error ?? 'Error'}</span>
                ) : (
                  <span className={styles.statusSuccess}>OK</span>
                )}
              </td>
              <td>
                {step.changes.length > 0 ? (
                  step.changes.map((c, i) => {
                    const delta = c.after - c.before;
                    const cls = delta > 0 ? styles.changePositive : delta < 0 ? styles.changeNegative : '';
                    const addr = c.address === '__escrow__' ? 'Escrow' : c.address;
                    return (
                      <div key={i}>
                        <span>{addr}: </span>
                        <span className={cls}>
                          {delta > 0 ? '+' : ''}{delta} {c.asset}
                        </span>
                        <span style={{ color: '#666', fontSize: 9, marginLeft: 4 }}>
                          ({c.before}→{c.after})
                        </span>
                      </div>
                    );
                  })
                ) : (
                  <span style={{ color: '#666' }}>—</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
